import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Button, 
  Paper,
  Container
} from '@mui/material';
import { 
  SentimentDissatisfied as SadIcon,
  Home as HomeIcon
} from '@mui/icons-material';
import { motion } from 'framer-motion';

function NotFoundPage() {
  return (
    <Container maxWidth="md">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: { xs: 4, md: 6 }, 
            mt: 4, 
            textAlign: 'center',
            borderRadius: 2
          }}
        >
          <Box sx={{ mb: 4 }}>
            <SadIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
              404 - Page Not Found
            </Typography>
            <Typography variant="h6" color="text.secondary" paragraph>
              Oops! The page you are looking for doesn't exist or has been moved.
            </Typography>
          </Box>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            component={RouterLink}
            to="/"
            sx={{ px: 4, py: 1.5 }}
          >
            Back to Home
          </Button>
          
          <Box sx={{ mt: 6 }}>
            <Typography variant="body2" color="text.secondary">
              If you believe this is an error, please contact support.
            </Typography>
          </Box>
        </Paper>
      </motion.div>
    </Container>
  );
}

export default NotFoundPage;